import React from 'react';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import format from 'string-template';
import { connect } from 'react-redux';

import { STATIC_ROOT } from '../../../constants';
import { MODAL_TYPE_LOGIN_FAILED } from '../../../services/modal/constants';
import { EMAIL_ALREADY_USED_STATUS_CODE } from '../../../services/enrollment/constants';

import { hideModal, showModal } from '../../../services/modal/actions';
import { sendEnrollmentRequest } from '../../../services/enrollment/actions';
import { findTemporaryUserRequest } from '../../../services/tempuser/actions';

import { clickEvent, pageDisplay } from '../../../utils';
import { getClientUrl } from '../../../utils/ssoUtil';

import {
    FormComponent,
    CheckboxInputFieldComponent,
    LegendFieldComponent
} from '../../../components/form';
import SvgComponent from '../../SvgComponent';
import ButtonComponent from '../../button/ButtonComponent';
import { LoadingComponent } from '../../loading/LoadingComponent';

import './EnrollModalComponent.scss';

class EnrollModalComponent extends React.Component {
    componentDidMount() {
        const { findTemporaryUserRequest, uuid } = this.props;
        pageDisplay('popin_confirmation_adhesion');
        findTemporaryUserRequest(uuid);
    }

    componentDidUpdate(prevProps) {
        const {
            errorTempUser,
            showModal,
            hideModal,
            successEnrollmentSubmit,
            requestTempUser
        } = this.props;

        // Focus par défaut sur la case à cocher newsletter une fois le user
        // temporaire chargé (à l'ouverture, seul le loader est affiché et le
        // focus initial posé par ModalRoot reste sur la croix de fermeture)
        if (prevProps.requestTempUser && !requestTempUser) {
            const checkbox = document.querySelector('#newsletter-0');
            if (checkbox) {
                checkbox.focus();
            }
        }

        if (errorTempUser) {
            showModal(MODAL_TYPE_LOGIN_FAILED, {
                id: 'login-failed',
                actionOnClose: () => {
                    window.location = getClientUrl();
                }
            });
        }
        if (successEnrollmentSubmit) {
            hideModal();
        }
    }

    submit = values => {
        const { sendEnrollmentRequest, uuid } = this.props;

        values.uuid = uuid;
        sendEnrollmentRequest(values);
    };

    render() {
        const {
            i18n,
            requestTempUser,
            errorMessage,
            requestSubmit,
            errorSubmit,
            statusCode,
            user
        } = this.props;

        return (
            <div className="modal-enrollment">
                <div className="container-header">{i18n.HEADER}</div>
                <div className="container-body">
                    {requestTempUser ? (
                        <LoadingComponent />
                    ) : (
                        <React.Fragment>
                            <div className="container-text">
                                <p>{format(i18n.GREETING, user.firstname)}</p>
                                <p>{i18n.TEXT1}</p>
                                <p>{i18n.TEXT2}</p>
                            </div>

                            <FormComponent
                                form="enrollment-form"
                                onSubmit={this.submit}
                                requestSubmit={requestSubmit}
                                errorSubmit={errorSubmit}
                                hideButton>
                                <React.Fragment>
                                    {errorSubmit && statusCode === EMAIL_ALREADY_USED_STATUS_CODE && (
                                        <LegendFieldComponent classNameInputContainer="color-err err-picto">
                                            <div className="picto">
                                                <SvgComponent
                                                    src={`${STATIC_ROOT}/picto-errors.svg`}
                                                    width={20}
                                                    height={20}
                                                    aria-hidden="true"
                                                />
                                            </div>
                                            <div>{i18n.EMAIL_ALREADY_USED}</div>
                                        </LegendFieldComponent>
                                    )}
                                </React.Fragment>
                                <CheckboxInputFieldComponent
                                    name="newsletter"
                                    classNameInputContainer="box-input"
                                    options={[{ label: i18n.LABEL_NEWSLETTER, value: 1 }]}
                                />
                                <React.Fragment>
                                    <div className="container-button">
                                        <ButtonComponent
                                            type="submit"
                                            color="main"
                                            text={i18n.CTA_CONFIRM}
                                            onClick={clickEvent(
                                                'popin_confirmation_adhesion_bouton_confirmer',
                                                'popin_confirmation_adhesion'
                                            )}
                                        />
                                    </div>
                                </React.Fragment>
                                <React.Fragment>
                                    {errorSubmit &&
                                        statusCode !== EMAIL_ALREADY_USED_STATUS_CODE && (
                                            <LegendFieldComponent classNameInputContainer="color-err">
                                                {errorMessage}
                                            </LegendFieldComponent>
                                        )}
                                </React.Fragment>
                            </FormComponent>
                        </React.Fragment>
                    )}
                </div>
            </div>
        );
    }
}

EnrollModalComponent.propTypes = {
    i18n: PropTypes.object,
    uuid: PropTypes.string
};

// Which props do we want to inject, given the global state?
const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.ENROLLMENT_MODAL,
        user: state.temporaryuser.user,
        requestTempUser: state.temporaryuser.fetching || false,
        errorTempUser: !isEmpty(state.temporaryuser.error),
        successEnrollmentSubmit: state.enrollment.successEnrollmentSubmit,
        requestSubmit: state.enrollment.fetching || false,
        errorMessage: state.enrollment.error || '',
        errorSubmit: !isEmpty(state.enrollment.error),
        statusCode: state.enrollment.status
    };
};

const mapDispatchToProps = {
    showModal,
    hideModal,
    sendEnrollmentRequest,
    findTemporaryUserRequest
};

export default connect(mapStateToProps, mapDispatchToProps)(EnrollModalComponent);



// WEBPACK FOOTER //
// ./src/components/authentication/enrollment/EnrollModalComponent.js